// extracted by mini-css-extract-plugin
module.exports = {"layout":"EssentialPricePlanDashboard_layout__3st--","contentWrapper":"EssentialPricePlanDashboard_contentWrapper__1QFG9","pricePlan":"EssentialPricePlanDashboard_pricePlan__1VjBu"};